import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Pagination from '@components/Pagination/Pagination'
import Search from '@components/pages/Transaction/Search'
import Table from '@components/pages/Transaction/ListTable'
import GET_TRANSACTIONS from '@graphql/queries/get-transactions'

function List() {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchFilters = Object.fromEntries(searchParams)
  const { data, loading, error, refetch } = useQuery(GET_TRANSACTIONS, {
    variables: { filters: searchFilters }
  })

  return (
    <>
      <PageHeading heading='Transactions' />

      {error ? (
        <Error error={error} />
      ) : (
        <>
          <Search
            refetch={refetch}
            searchFilters={searchFilters}
            setSearchParams={setSearchParams}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.transactions?.metadata}
          />
          <Table
            totalCount={data?.transactions?.metadata?.totalCount}
            transactions={data?.transactions?.collection || []}
            loading={loading}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.transactions?.metadata}
          />
        </>
      )}
    </>
  )
}

export default List
